module.exports = __webpack_public_path__ + "images/emoji/aries.fd4dd4a9e2f928194a36.png";